"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicVideoCards = void 0;
var tslib_1 = require("tslib");
var public_catalog_service_1 = require("../../../catalog-services/public-catalog-service");
var PublicVideoCards = /** @class */ (function (_super) {
    tslib_1.__extends(PublicVideoCards, _super);
    function PublicVideoCards() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get list of video cards for given video in channel
     * @param channelId
     * @param videoId
     * @param requestConfig
     */
    PublicVideoCards.prototype.getList = function (channelId, videoId, requestConfig) {
        return this.get("/public/lists/".concat(channelId, "/items/").concat(videoId, "/actions"), requestConfig);
    };
    return PublicVideoCards;
}(public_catalog_service_1.PublicCatalogService));
exports.PublicVideoCards = PublicVideoCards;
//# sourceMappingURL=video-cards.js.map